import React, { useEffect, useState } from "react";
import Version from "../../../package.json";
import axios from "axios";
import { useSnackbar } from "notistack";
import PouchDB from "pouchdb-browser";
import * as firebase from "firebase";
import Swal from "sweetalert2";
/*---end map---*/
//material ui components
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InputBase from "@material-ui/core/InputBase";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import Popover from "@material-ui/core/Popover";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";

// material ui icons
import SignOutIcon from "@material-ui/icons/ExitToApp";
import HomeIcon from "@material-ui/icons/Home";
import UserIcon from "@material-ui/icons/Person";
import PeopleIcon from "@material-ui/icons/People";
import MenuIcon from "@material-ui/icons/Menu";
import MailIcon from "@material-ui/icons/Mail";
import NotificationsIcon from "@material-ui/icons/Notifications";
import SearchIcon from "@material-ui/icons/Search";
import SaveIcon from "@material-ui/icons/Save";
import AssignmentIcon from "@material-ui/icons/Assignment";
import RefreshIcon from "@material-ui/icons/Refresh";
import EditIcon from "@material-ui/icons/Edit";
import AllInboxIcon from "@material-ui/icons/AllInbox";
//styles
import useStyles from "./styles";

//react router
import { Switch, Route, Link } from "react-router-dom";

// komponen halaman private
import Profile from "./profile";
import Home from "./home";
import List from "./list";
import Rekap from "./rekap";
import Draft from "./list-draft";
import Local from "./list-local";
import Form from "./forms/index";
import EditForm from "./forms/edit";
import DefOP from "./definisi-op/index";
import { usePouchDB } from "../../components/PouchDB/PouchDBProvider";
import { useDataSync } from "../../components/PouchDB/DataSyncProvider";
import Copyright from "../../components/Copyright";
//images
import logo from "../../images/PK25.png";
import { Divider } from "@material-ui/core";
import qs from "query-string";

import SyncInfo from "../../components/SyincInfo";

// offline detector
import { Detector } from "react-detect-offline";
import Connected from "@material-ui/icons/Wifi";
import Disconnected from "@material-ui/icons/WifiOff";
import Tooltip from "@material-ui/core/Tooltip";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";

const API_URL = process.env.REACT_APP_API_DEVELOPMENT_URL;
const API_CONFIG_URL = process.env.REACT_APP_API_CONFIG_URL;
const API_DATA = process.env.REACT_APP_API_DATA;

const USER_KEY_PG = process.env.REACT_APP_USER_KEY_PROXY_GATEWAY;
const USER_KEY_AUTH = process.env.REACT_APP_USER_KEY_AUTH;

export default function Private({ history, match, location }) {
  const classes = useStyles();
  const queryString = qs.parse(location.search);
  const { logoutAndClearLocal, user, setUser, dataBkkbn } = usePouchDB();
  const { isSyncing, manualSync, isManualSyncing } = useDataSync();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElSearch, setAnchorElSearch] = React.useState(null);
  const [blocking, setBlocking] = React.useState(false);
  const [pgsPutCdb, setPgsPutCdb] = React.useState(false);
  const [labelPut, setLabelPut] = React.useState(
    "Please wait, checking data resource"
  );
  const [countPut, setCountPut] = React.useState(0);
  const [totalData, setTotalData] = React.useState(0);
  const [flagFirstLogin, setFlagFirstLogin] = React.useState(
    user.flagFirstLogin
  );
  const [newPass, setNewPass] = React.useState("");
  const [confPass, setConfPass] = React.useState("");

  const db_name = localStorage.getItem("db_name");
  const remote_base = localStorage.getItem("remote_base");
  const url = remote_base + "/" + db_name;
  const url_split = remote_base ? remote_base.split("/") : "";
  const couchdb = url_split[url_split.length - 1];

  const { enqueueSnackbar } = useSnackbar();

  const [opr, setOpr] = useState(localStorage.getItem("opr"));
  const [localRw, setLocalRw] = useState(localStorage.getItem("rw"));
  const [dataBkkbnDocs, setDataBkkbnDocs] = useState(0);

  const [targetkk, setTragetKK] = useState(0);
  const [totalDataKKAll, setTotalDataKKAll] = useState(0);
  const [lock, setLock] = useState(localStorage.getItem("lock"));

  const [open, setOpen] = React.useState(false);
  const [openTotalTarget, setOpenTotalTarget] = React.useState(false);
  const [lockWilayah, setLockWilayah] = useState(
    localStorage.getItem("lockWilayah")
  );
  const [lockTarget, setLockTarget] = useState(
    localStorage.getItem("lockTarget")
  );

  const handleClickSearch = (event) => {
    setAnchorElSearch(event.currentTarget);
  };

  useEffect(() => {
    //cek versi --> false --> clear cache & local data
    const checkVersion = async () => {
      const versi = Version.version;
      // axios.get(`${API_CONFIG_URL}/pk/pwaConfig/getPWAVersion` + '?user_key=' + USER_KEY_PG, {
      axios
        .get(`${API_CONFIG_URL}/pk/pwaConfig/getPWAVersion`, {
          // headers: { user_key: USER_KEY_PG }
          headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
        })
        .then((res) => {
          // console.log(res, 'res version')
          if (res.status == "200") {
            if (res.data !== versi) {
              // console.log('run beda versi')
              const clearCacheData = async () => {
                caches.keys().then(function (cacheNames) {
                  cacheNames.forEach(function (cacheName) {
                    caches.delete(cacheName);
                  });
                });
              };
              // clearCacheData().then(handleSignOut())
              clearCacheData().then(console.log("clear chache jalan"));
              // clearCacheData().then(setUser({isLoggedIn: false,loading: true}))
              const clearLogin = async () => {
                try {
                  const dataFrontend = new PouchDB("frontend");
                  const localsession = await dataFrontend.get("auth");
                  let userCtx = {};
                  let metadata = {};

                  dataFrontend.remove(localsession);
                  localStorage.removeItem("notification-token");
                  firebase.messaging().deleteToken();
                  localStorage.removeItem("db_name");
                  localStorage.removeItem("remote_base");
                  localStorage.removeItem("opr");
                  localStorage.removeItem("rw");

                  console.log(
                    "remove datafrontend, localstorage, and firebase token run"
                  );

                  setUser((user) => ({
                    ...user,
                    userCtx,
                    isLoggedIn: false,
                    metadata,
                  }));

                  console.log("Logout with hout API success");
                } catch (e) {
                  console.log(JSON.stringify(e));
                  if (e.name === "not_found") {
                    setUser((user) => ({ ...user, isLoggedIn: false }));
                  }
                }
              };
              Swal.fire({
                title: "Peringatan",
                icon: "warning",
                text:
                  "Terdapat perbedaan versi aplikasi dengan server, halaman akan diarahkan ke Login. Server version " +
                  res.data,
              }).then(function () {
                clearLogin();
              });
            }
          } else {
            enqueueSnackbar("ERROR: " + res.status, { variant: "error" });
          }
        })
        .catch(function (error) {
          console.log("Err => ", error);
          enqueueSnackbar(
            "Tidak ada koneksi internet untuk melakukan cek versi aplikasi : " +
              error.message,
            { variant: "info" }
          );
        });
    };
    checkVersion();

    // const fetchData = async () => {
    //     const query = await dataBkkbn.local.find({
    //         selector: {
    //             // periode_sensus: { $eq: '2021' }
    //             // _id: { $eq: '1617193181935p1109012020-01KPSUAKBARU' }
    //         }
    //     });

    //     const rw = user.metadata.wil_rw
    //     let idRt = []
    //     for(let i=0; i<rw.length;i++){
    //         let rt = rw[i].wil_rt
    //         for(let j=0; j<rt.length;j++){
    //             idRt.push(+rt[j].id_rt)
    //         }
    //     }
    //     // console.log(idRt, 'cek id RT')

    //     // console.log(query, 'query dataBkkbn')
    //     //delete local data - old doc
    //     // console.log(user, 'run check')
    //     for (const doc of query.docs) {
    //         const x = idRt.filter(o=> o === +doc.id_rt && doc.periode_sensus === "2022")
    //         if(x.length === 0){
    //             if(doc.user_name === user.metadata.name){
    //                 dataBkkbn.local.remove(doc._id, doc._rev, function (err) {
    //                     if (err) {
    //                         return console.log(err);
    //                     } else {
    //                         console.log(doc._id, "Document deleted successfully");
    //                     }
    //                 });
    //             }
    //         }

    //     }

    //     //download old data from API if local data & server data = 0
    //     try {
    //         setBlocking(true)
    //         // console.log(localStorage.getItem("remote_base"), 'remote_base')
    //         // console.log(localStorage.getItem("db_name"), 'db_name')
    //         const url = localStorage.getItem("remote_base") + '/' + localStorage.getItem("db_name")
    //         const idKel = +user.metadata.wil_kelurahan.id_kelurahan
    //         const idProv = +user.metadata.wil_provinsi.id_provinsi
    //         const rw = user.metadata.wil_rw
    //         let idRt = []
    //         for(let i=0; i<rw.length;i++){
    //             let rt = rw[i].wil_rt
    //             for(let j=0; j<rt.length;j++){
    //                 idRt.push(+rt[j].id_rt)
    //             }
    //         }
    //         // const res = await axios.get(url + '?user_key=' + USER_KEY_PG + '&idKelurahan=' + idKel + '&periodeSensus=2022' + '&username=' + user.metadata.name)
    //         // const { data } = await res;
    //         axios.post(url + '?idProvinsi=' + idProv + '&idKelurahan=' + idKel + '&periodeSensus=2022' + '&username=' + user.metadata.name, idRt, {headers: {
    //             user_key: USER_KEY_PG
    //         }}).then(response => {
    //             // do something with response
    //             // console.log(response, 'response get')
    //             let totalData = (response && response.data.length > 0) ? response.data.length : 0
    //             // console.log(response.data,'proxy gateway retrieve')
    //             // console.log(totalData, 'totalData')
    //             setPgsPutCdb(true)
    //             setTotalData(totalData)
    //             if (totalData > 0) {
    //                 try {
    //                     setLabelPut("Please wait, load inisial data from PK-22")
    //                     let resp = []
    //                     let promises = [];
    //                     let x = 0
    //                     //set remote
    //                     for (let i = 0; i < totalData; i++) {
    //                         let obj = response.data[i]
    //                         delete obj._rev;
    //                         const localObj = {
    //                             ...obj,
    //                             status_sensus: 'Tersimpan'
    //                         }
    //                         try {
    //                             dataBkkbn['local'].put(localObj)
    //                         }
    //                         catch (e) {
    //                             console.log(e, 'error')
    //                         }
    //                         const remoteObj = {
    //                             ...obj,
    //                             status_sensus: ''
    //                         }
    //                         promises.push(
    //                             axios.put(url + '/' + remoteObj._id + '/_put?couchdb=' + couchdb + '&database-name=' + db_name + '&_id=' + remoteObj._id, remoteObj, {headers: {
    //                                 user_key: USER_KEY_PG
    //                             }}).then(response => {
    //                                 // console.log(response, 'each response')
    //                                 x = x + 1
    //                                 // console.log(x, 'xxx')
    //                                 setCountPut(x)
    //                             }).catch((e) => {
    //                                 x = x + 1
    //                                 setCountPut(x)
    //                                 // setBlocking(false)
    //                             })
    //                         )
    //                     }
    //                     Promise.all(promises).then(() => {
    //                         setBlocking(false)
    //                     })
    //                 } catch (e) {
    //                     setBlocking(false)
    //                     enqueueSnackbar("Proses retrieve data PK-22 gagal, silakan coba lagi.", { variant: 'error' })
    //                 }
    //             } else {
    //                 setBlocking(false)
    //             }
    //         }).catch((e) => {
    //             setBlocking(false)
    //         })
    //     } catch (e) {
    //         setBlocking(false)
    //         enqueueSnackbar("Checking data resource failed, silakan coba lagi.", { variant: 'error' })
    //     }
    // }

    // fetchData()

    // getAllDataBkkbn();
  }, []);

  const handleCloseSearch = () => {
    setAnchorElSearch(null);
  };

  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleSignOut = async (e) => {
    // console.log("run handlesignout");
    localStorage.removeItem("dataServerCount");
    try {
      await logoutAndClearLocal();
    } catch (e) {
      console.log(e);
    }
  };

  const [openNotification, setOpenNotification] = React.useState(null);

  const handleClickNotification = (event) => {
    if (openNotification && openNotification.contains(event.target)) {
      setOpenNotification(null);
    } else {
      setOpenNotification(event.currentTarget);
    }
    isSyncing.statusNotif.count = 0;
  };

  const handleCloseNotification = () => {
    setOpenNotification(null);
  };

  const handleClick = (e) => {
    handleCloseNotification();
    history.push("/list");
  };

  const handleClickDraft = (e) => {
    history.push("/list-draft");
  };

  const handleClose = () => {
    setOpen(false);
  };

  const AlertDialog = () => {
    return (
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Pemberitahuan"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Saat ini semua taransaksi Insert atau Edit data telah ditutup
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Tutup
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  };

  const handlePass = (e) => {
    const { name, value } = e.target;
    if (name === "newPass") {
      setNewPass(value);
    } else {
      setConfPass(value);
    }
  };

  const stringCek = (string) => {
    const upper = /[A-Z]/.test(string),
      lower = /[a-z]/.test(string),
      number = /[0-9]/.test(string),
      symbol = /[!@#$%^&*(),.?":{}|<>_\-\\/~`+=]/.test(string);

    return upper && lower && number & symbol;
  };

  const passValidation = () => {
    let msg = "";
    const cek = stringCek(newPass);
    console.log(cek, "cek string");
    if (newPass !== confPass) {
      msg = "Konfirmasi password tidak sesuai";
    }

    if (newPass.length === 0 || confPass.length === 0) {
      msg = "Password baru dan konfirmasi password harus diisi";
    }

    for (let i = 0; i <= newPass.length - 4; i++) {
      const slice = newPass.slice(i, i + 4);
      if (/^\d{4}$/.test(slice)) {
        const nums = slice.split("").map(Number);
        if (
          nums.every((val, idx, arr) => idx === 0 || val - arr[idx - 1] === 1)
        ) {
          msg = "Kata sandi tidak boleh mengandung angka berurutan 4 digit";
        }
        if (new Set(nums).size === 1) {
          msg = "Kata sandi tidak boleh mengandung angka yang sama 4 digit";
        }
      }
    }

    if (!cek) {
      msg =
        "Password harus gabungan huruf kecil, huruf besar, angka dan karakter khusus";
    }

    if (newPass.length < 8) {
      msg = "Kata sandi minimal terdiri dari 8 karakter";
    }

    return msg;
  };

  const handleSimpanPass = () => {
    const cekValidation = passValidation();
    if (cekValidation.length > 0) {
      Swal.fire({
        title: "Peringatan",
        icon: "warning",
        text: cekValidation,
      });
    } else {
      const dt = new Date();
      const payload = {
        password: newPass,
        updateBy: user.metadata.name,
        updateDate: dt.toISOString(),
        username: user.metadata.name,
      };
      axios
        .put(
          `${API_URL}/api/changePassword?user_key=` + USER_KEY_AUTH,
          payload,
          {
            // headers: { user_key: USER_KEY_AUTH }
            headers: { Authorization: "Basic YWRtaW46cGFzc3dvcmQ=" },
          }
        )
        .then((res) => {
          if (res.status == "200") {
            const clearLogin = async () => {
              try {
                const dataFrontend = new PouchDB("frontend");
                const localsession = await dataFrontend.get("auth");
                let userCtx = {};
                let metadata = {};

                dataFrontend.remove(localsession);
                localStorage.removeItem("notification-token");
                firebase.messaging().deleteToken();
                localStorage.removeItem("db_name");
                localStorage.removeItem("remote_base");
                localStorage.removeItem("opr");
                localStorage.removeItem("rw");

                console.log(
                  "remove datafrontend, localstorage, and firebase token run"
                );

                setUser((user) => ({
                  ...user,
                  userCtx,
                  isLoggedIn: false,
                  metadata,
                }));

                console.log("Logout with hout API success");
              } catch (e) {
                console.log(JSON.stringify(e));
                if (e.name === "not_found") {
                  setUser((user) => ({ ...user, isLoggedIn: false }));
                }
              }
            };
            Swal.fire({
              title: "Sukses",
              icon: "success",
              text: "Ubah password berhasil, halaman akan diarahkan ke Login.",
            }).then(function () {
              clearLogin();
            });
          }
        })
        .catch(function (error) {
          Swal.fire({
            title: "Gagal",
            icon: "warning",
            text: error,
          });
        });
    }
  };

  return (
    <div className={classes.root}>
      {!blocking ? (
        <>
          {!flagFirstLogin ? (
            <>
              <AppBar position="absolute" className={classes.appBar}>
                <Toolbar className={classes.toolbar}>
                  <Hidden xsDown>
                    <div className={classes.title}>
                      <Link to="/">
                        <img src={logo} alt="logo" className={classes.logo} />
                      </Link>
                    </div>

                    <div className={classes.search}>
                      <div className={classes.searchIcon}>
                        <SearchIcon className={classes.iconColor} />
                      </div>
                      <InputBase
                        placeholder="Search…"
                        classes={{
                          root: classes.inputRoot,
                          input: classes.inputInput,
                        }}
                        inputProps={{ "aria-label": "search" }}
                        value={queryString.query || ""}
                        onChange={(e) => {
                          let val = e.target.value;
                          let value = val.replace(/ /g, "%20");
                          history.push({
                            pathname: window.location.pathname,
                            search: `?query=${value}`,
                          });
                        }}
                      />
                    </div>
                  </Hidden>
                  <Hidden smUp>
                    <div className={classes.searchMobile}>
                      <IconButton
                        onClick={handleClickSearch}
                        aria-label="show 4 new mails"
                      >
                        <SearchIcon className={classes.iconColor} />
                      </IconButton>
                      <Popover
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        anchorEl={anchorElSearch}
                        open={Boolean(anchorElSearch)}
                        onClose={handleCloseSearch}
                      >
                        <InputBase
                          autoFocus
                          placeholder="Search…"
                          classes={{
                            root: classes.inputRoot,
                            input: classes.inputInputMobile,
                          }}
                          inputProps={{ "aria-label": "search" }}
                          value={queryString.query || ""}
                          onChange={(e) => {
                            history.push({
                              pathname: window.location.pathname,
                              search: `?query=${e.target.value}`,
                            });
                          }}
                        />
                      </Popover>
                    </div>
                  </Hidden>

                  <div className={classes.space}></div>
                  {isSyncing.syncBkkbn ? (
                    <Tooltip title="Syncing..." aria-label="syncing">
                      <CircularProgress size={24} />
                    </Tooltip>
                  ) : (
                    <Detector
                      render={({ online }) => {
                        return online ? (
                          <Connected className="noOutline" />
                        ) : (
                          <Disconnected className={classes.iconColor} />
                        );
                      }}
                    />
                  )}
                  {/* tambahan */}

                  {isManualSyncing ? (
                    <>
                      <Tooltip
                        title="Proses Replikasi sedang berlangsung"
                        aria-label="syncing"
                      >
                        <IconButton
                          aria-label="Manual Sync"
                          className="noOutline"
                        >
                          <CircularProgress
                            style={{ color: "white" }}
                            size={24}
                          />
                        </IconButton>
                      </Tooltip>
                    </>
                  ) : (
                    <>
                      <Tooltip title="Replikasi" aria-label="syncing">
                        <IconButton
                          disabled={isManualSyncing}
                          onClick={manualSync}
                          aria-label="Manual Sync"
                          className="noOutline"
                        >
                          <RefreshIcon />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                  {/* end */}
                  {/* <IconButton aria-label="show 4 new mails" className='noOutline' onClick={handleMaps}>
                            <Badge badgeContent={0} color="secondary">
                                <MailIcon />
                            </Badge>
                        </IconButton> */}

                  <IconButton
                    aria-label="show 17 new notifications"
                    className={classes.iconColor}
                    onClick={handleClickNotification}
                  >
                    <Badge
                      badgeContent={isSyncing.statusNotif.count}
                      color="secondary"
                    >
                      <NotificationsIcon />
                    </Badge>
                    <Hidden xsDown implementation="css">
                      <p
                        onClick={handleCloseNotification}
                        className={classes.linkText}
                      ></p>
                    </Hidden>
                  </IconButton>

                  <Menu
                    id="menu-notif"
                    open={Boolean(openNotification)}
                    anchorEl={openNotification}
                    keepMounted
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                    onClose={handleCloseNotification}
                    getContentAnchorEl={null}
                  >
                    {isSyncing.statusNotif.message.length <= 0 && (
                      <MenuItem>Belum ada notifikasi</MenuItem>
                    )}
                    {isSyncing.statusNotif.message.length > 0 &&
                      isSyncing.statusNotif.message.map((item, index) => (
                        <MenuItem
                          key={item}
                          onClick={handleClick}
                          className={classes.notifItem}
                        >
                          {item.content}
                        </MenuItem>
                      ))}
                  </Menu>

                  <IconButton
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleClickMenu}
                    color="inherit"
                    className="noOutline"
                  >
                    <Avatar className={classes.orangeAvatar}>
                      {user.metadata.firstName.charAt(0) +
                        user.metadata.lastName.charAt(0)}
                    </Avatar>
                  </IconButton>
                  <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={Boolean(anchorEl)}
                    onClose={handleCloseMenu}
                  >
                    <MenuItem>
                      <ListItemIcon>
                        <UserIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary={user.metadata.name} />
                    </MenuItem>
                    <Divider />
                    <MenuItem
                      onClick={() => {
                        history.push("/profile");
                        handleCloseMenu();
                      }}
                    >
                      <ListItemIcon>
                        <UserIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Profile" />
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        history.push("/");
                        handleCloseMenu();
                      }}
                    >
                      <ListItemIcon>
                        <HomeIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Home" />
                    </MenuItem>
                    {user.metadata?.name.substring(0, 4).toLowerCase() !==
                      "prob" && (
                      <MenuItem
                        onClick={() => {
                          {
                            lock == "true"
                              ? setOpen(true)
                              : history.push("/form");
                          }
                          handleCloseMenu();
                        }}
                      >
                        <ListItemIcon>
                          <EditIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="Isi Form Pendataan Keluarga" />
                      </MenuItem>
                    )}
                    <MenuItem
                      onClick={() => {
                        history.push("/rekap");
                        handleCloseMenu();
                      }}
                    >
                      <ListItemIcon>
                        <AssignmentIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Rekap RT" />
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        history.push("/list");
                        handleCloseMenu();
                      }}
                    >
                      <ListItemIcon>
                        <PeopleIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Daftar Keluarga" />
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        history.push("/list-draft");
                        handleCloseMenu();
                      }}
                    >
                      <ListItemIcon>
                        {dataBkkbnDocs == 0 ? (
                          <>
                            <SaveIcon fontSize="small" />
                          </>
                        ) : (
                          <>
                            <Badge
                              color="secondary"
                              badgeContent={dataBkkbnDocs}
                              showZero
                            >
                              <SaveIcon fontSize="small" />
                            </Badge>
                          </>
                        )}
                      </ListItemIcon>
                      <ListItemText primary="Daftar Draft" />
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        history.push("/list-local");
                        handleCloseMenu();
                      }}
                    >
                      <ListItemIcon>
                        <AllInboxIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Data Lokal" />
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={handleSignOut}>
                      <ListItemIcon>
                        <SignOutIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Logout" />
                    </MenuItem>
                  </Menu>
                </Toolbar>
              </AppBar>

              <main className={classes.content}>
                <div className={classes.appBarSpacer} />

                <Container maxWidth="md" className={classes.container}>
                  {/* <div>Cek Versi</div> */}
                  <SyncInfo />
                  <Switch>
                    <Route exact path="/form" component={Form} />
                    <Route path="/profile" component={Profile} />
                    <Route path="/form/edit/:_id" component={EditForm} />
                    <Route path="/list" component={List} />
                    <Route path="/rekap" component={Rekap} />
                    <Route path="/list-draft/" component={Draft} />
                    <Route path="/list-local/" component={Local} />
                    <Route path="/definisi-operasional" component={DefOP} />
                    <Route component={Home} />
                  </Switch>

                  <AlertDialog />
                </Container>
                <footer className={classes.footer}>
                  <Container maxWidth="sm">
                    <Copyright />
                  </Container>
                </footer>
              </main>
            </>
          ) : (
            <div
              style={{
                display: "flex",
                minHeight: "100vh",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "300px",
                  minHeight: "200px",
                  border: "1px solid #cdcdcd",
                  borderRadius: "4px",
                  padding: "1rem",
                }}
              >
                Silakan merubah password, dengan menggunakan gabungan huruf
                kecil, huruf besar, angka dan karakter khusus. (
                <i>ex: P4ssword$022</i>)
                <div style={{ width: "100%", margin: "1rem 0" }}>
                  <b>Password Baru</b>
                  <TextField
                    type="password"
                    name="newPass"
                    value={newPass}
                    onChange={handlePass}
                  />
                </div>
                <div style={{ width: "100%", margin: "1rem 0" }}>
                  <b>Konfirmasi Password Baru</b>
                  <TextField
                    type="password"
                    name="confPass"
                    value={confPass}
                    onChange={handlePass}
                  />
                </div>
                <Button
                  onClick={handleSimpanPass}
                  variant="contained"
                  color="primary"
                  style={{ color: "#fff", fontWeight: "600", fontSize: "12px" }}
                >
                  Simpan
                </Button>
              </div>
            </div>
          )}
        </>
      ) : (
        <div
          style={{
            display: "flex",
            minHeight: "100vh",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <b>
            <CircularProgress
              size={24}
              style={{ color: "#000", marginRight: "5px" }}
            />{" "}
            {labelPut}{" "}
            {pgsPutCdb && (
              <b>
                {countPut}/{totalData}
              </b>
            )}
          </b>
        </div>
      )}
    </div>
  );
}
